<template>
  <div class="font-inter h-[] bg-[#FFFFFF] rounded-t-[20px] mt-3">
    <NavbarComponent />
    <template v-if="loading">
      <SkeletonLoader v-for="n in 6" :key="n" width="100%" height="171px" />
    </template>

    <div v-else class="my-6 mx-8 h-[100vh] justify-between bg-primaryBg px-">
      <!-- Cover photo -->
      <img src="@/assets/settings/Image.svg" alt="team" class="rounded-lg" />

      <div class="flex w-full rounded-lg py-3 px-6 items-start justify-between">
        <div class="flex gap-3">
          <img
            v-if="getProfilePicture()"
            :src="getProfilePicture()"
            alt="Profile Picture"
            class="w-[160px] h-[160px] -mt-12 border-[4px] rounded-full border-primaryLight"
          />
          <UserAvatar
            v-else
            :fullName="fullName"
            class="w-[160px] h-[160px] -mt-12 border-[4px] rounded-full border-primaryLight"
          />
          <div class="space-y-3">
            <h1 class="text-[30px] text-primaryDark">
              {{ capitalize(talent.talent_first_name) }}
              {{ capitalize(talent.talent_last_name) }}
            </h1>
            <div class="grid grid-cols-3 gap-1 mb-4 text-center">
              <p
                v-for="role in getAvailableRoles()"
                :key="role"
                class="flex justify-center bg-[#5D5D5E] text-[11px] text-primaryLight px-2 py-[2px] rounded"
              >
                {{ capitalize(role) }}
              </p>
            </div>
            <!-- <button v-if="isInvestor"
              class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]">
              Edit Profile
            </button> -->

            <router-link
              v-if="isInvestor"
              :to="{ name: 'Settings' }"
              class="flex border-[1px] border-grayDark hover:bg-primaryDark hover:text-primaryLight text-primaryDark text-[14px] font-medium px-3 py-3 space-x-4 items-center rounded-[8px] h-[42px]"
            >
              Edit Profile
            </router-link>
          </div>
        </div>
        <div v-if="isAdmin || isManager || isTalent" class="flex gap-2">
          <img
            src="@/assets/settings/mdi_github.svg"
            alt="team"
            class="rounded-lg"
          />
          <img
            src="@/assets/settings/mingcute_dribbble-fill.svg"
            alt="team"
            class="rounded-lg"
          />
        </div>
      </div>

      <div
        v-if="isAdmin || isTalent || isManager || isInvestor"
        class="p-8 space-y-6"
      >
        <TabComponent
          :tabs="profileTabs"
          v-model="activeProfileTab"
          :compact="false"
        />
        <div
          v-if="activeProfileTab === 'About'"
          class="block space-y-8 md:flex gap-16"
        >
          <div class="space-y- w-[490px] text-[15px]">
            <p
              class="font-medium mb-2 flex items-center gap-2 text-primaryDarkBg"
            >
              About me
              <img
                @click="createBio"
                src="@/assets/settings/edit-2.svg"
                alt="team"
                class="rounded-lg"
              />
            </p>
            <span v-if="talent.bio" class="space-y-3 text-grayDark">
              <p>{{ talent.bio }}</p>
            </span>
            <button
              v-else
              type="submit"
              @click="createBio"
              class="flex items-center gap-2 text-[14px] text-grayDark"
            >
              <img src="@/assets/tasks/add.svg" alt="User icon" class="h-4" />
              Create Bio
            </button>

            <div class="" v-if="showModal">
              <div class="fixed inset-0 z-40 bg-black opacity-50"></div>

              <div
                class="modal-content w-full max-h-[90vh] relative bg-white m-auto flex-col flex rounded-lg z-50"
              >
                <div class="w-full border-b-[1px] mb-4 px-6 py-4">
                  <h2 class="text-[18px] text-grayDark font-bold">Add Bio</h2>
                </div>

                <form
                  @submit.prevent="submitModal"
                  class="overflow-y-auto px-6"
                >
                  <div class="mb-4 space-y-4">
                    <div class="">
                      <label class="block text-[13px] font-medium text-grayDark"
                        >Bio</label
                      >
                      <textarea
                        v-model="newBio.bio"
                        placeholder="Enter a brief description of yourself"
                        class="mt-1 block w-full h-[152px] px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div class="flex justify-end mb-4 text-[14px]">
                    <button
                      type="button"
                      class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded"
                      @click="closeModal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      class="flex items-center gap-2 py-2 px-4 bg-primaryDarkBg w-[] h-[42px] text-white rounded"
                    >
                      <img
                        src="@/assets/dashboard/add.svg"
                        alt="User icon"
                        class="h-4"
                      />
                      Create Bio
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            v-if="isTalent"
            class="grid grid-cols-2 gap-4 text-grayDark text-[13px]"
          >
            <div class="space-y-2">
              <p class="font-medium">Portfolio</p>
              <p class="flex gap-2">
                {{ talent.portfolio_url }}
                <img
                  src="@/assets/settings/Copy.svg"
                  alt="copy"
                  class="rounded-lg cursor-pointer hover:opacity-70"
                  @click="
                    copyWithTooltip(
                      $event,
                      talent.portfolio_url,
                      'Portfolio URL copied!'
                    )
                  "
                  title="Copy portfolio URL"
                />
                <img
                  src="@/assets/settings/edit-2.svg"
                  alt="edit"
                  class="rounded-lg cursor-pointer hover:opacity-70"
                  @click="updatePortfolio"
                  title="Edit portfolio"
                />
                <img
                  src="@/assets/settings/arrow-up-right.svg"
                  alt="open"
                  class="rounded-lg cursor-pointer hover:opacity-70"
                  @click="openUrl(talent.portfolio_url)"
                  title="Open portfolio"
                />
              </p>
            </div>

            <div class="space-y-2">
              <p class="font-medium">Email</p>
              <p class="flex gap-2">
                {{ talent.talent_email }}
                <img
                  src="@/assets/settings/Copy.svg"
                  alt="copy"
                  class="rounded-lg cursor-pointer hover:opacity-70"
                  @click="
                    copyWithTooltip(
                      $event,
                      talent.talent_email,
                      'Email copied!'
                    )
                  "
                  title="Copy email"
                />

                <img
                  src="@/assets/settings/arrow-up-right.svg"
                  alt="email"
                  class="rounded-lg cursor-pointer hover:opacity-70"
                  @click="openEmailClient(talent.talent_email)"
                  title="Send email"
                />
              </p>
            </div>
            <div class="space-y-2">
              <p class="font-medium">Position</p>
              <p class="flex gap-2">
                {{ talent.position || "Software Engineer" }}
                <img
                  src="@/assets/settings/edit-2.svg"
                  alt="edit"
                  class="rounded-lg cursor-pointer"
                  @click="updatePosition"
                  title="Edit position"
                />
              </p>
            </div>
            <div class="space-y-2">
              <p class="font-medium">Skills & Expertise</p>
              <div
                v-if="skills"
                class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4"
              >
                <div
                  v-for="(skill, index) in talent.skills"
                  :key="index"
                  class="text-[14px]"
                >
                  <p class="px-2 py-1 bg-[#E5E7ED] rounded-lg text-center">
                    {{ skill.skill_name }}
                    <img
                      src="@/assets/settings/edit-2.svg"
                      alt="team"
                      class="rounded-lg"
                    />
                  </p>
                </div>
              </div>
              <div v-else>
                <p @click="addSkills">Add skills</p>
              </div>
            </div>
          </div>
          <!-- Investor and manager have same fields -->
          <div
            v-if="isManager || isInvestor"
            class="grid grid-cols-2 gap-4 text-grayDark text-[13px]"
          >
            <div class="space-y-2">
              <p class="font-medium">Industry</p>
              <p class="flex gap-2">
                {{ isManager ? manager.industry : investor.industry }}
                <img
                  src="@/assets/settings/Copy.svg"
                  alt="team"
                  class="rounded-lg"
                />
                <img
                  src="@/assets/settings/edit-2.svg"
                  alt="team"
                  class="rounded-lg"
                />
                <img
                  src="@/assets/settings/arrow-up-right.svg"
                  alt="team"
                  class="rounded-lg"
                />
              </p>
            </div>
            <div class="space-y-2">
              <p class="font-medium">Email</p>
              <p class="flex gap-2">
                {{ isManager ? manager.contact_email : investor.contact_email }}
                <img
                  src="@/assets/settings/Copy.svg"
                  alt="team"
                  class="rounded-lg"
                />
                <img
                  src="@/assets/settings/edit-2.svg"
                  alt="team"
                  class="rounded-lg"
                />
                <img
                  src="@/assets/settings/arrow-up-right.svg"
                  alt="team"
                  class="rounded-lg"
                />
              </p>
            </div>
          </div>
        </div>

        <div v-else-if="activeProfileTab === 'Talent Portfolio'">
          <div
            class="w-[556px] mx-auto border border-grayLight rounded-full align-center py-5 px-8 mx- space-x-6 flex items-center bg-white-to-gray"
          >
            <div class="flex space-x-2 items-center">
              <p class="text-[20px] text-bodyText font-bold">
                {{ completedProjectsCount }}
              </p>
              <p class="text-[13px] text-grayDark">Goals done</p>
            </div>
            <div class="h-8 w-[1px] bg-grayLight"></div>
            <div class="flex space-x-2 items-center">
              <p class="text-[20px] text-bodyText font-bold">
                {{ completedTasksCount }}
              </p>
              <p class="text-[13px] text-grayDark">Tasks Completed</p>
            </div>
            <div class="h-8 w-[1px] bg-grayLight"></div>
            <div class="flex space-x-2 items-center">
              <p class="flex gap-2 text-[20px] text-bodyText font-bold">0.0</p>

              <p class="text-[13px] text-grayDark">Average Rating</p>
            </div>
          </div>
          <div class="mt-10">
            <div class="grid grid-cols-3 md:grid-cols-3 gap-4">
              <div
                v-for="project in talentProjects"
                :key="project.project_id"
                @click="goToProject(project.project_id)"
                class="p-4 border border-[#EEEEEE] rounded-[8px] cursor-pointer hover:shadow-md transition-shadow"
              >
                <div
                  v-if="project.cover_image"
                  class="flex items-center"
                >
                  <img
                    :src="project.cover_image"
                    alt="Profile Picture"
                    class="rounded-lg w-291 h-[134px]"
                  />
                </div>
                <div v-else>
                  <img
                    src="@/assets/projects/default_cover_image.png"
                    alt="team"
                    class="rounded-lg w-full h-[134px]"
                  />
                </div>
                <div class="space-y-4 text-[12px]">
                  <span class="text-bodyText space-y-1">
                    <p
                      class="font-semibold text-[13px]"
                      @click="openSideMenu(project)"
                    >
                      {{ project.project_name }}
                    </p>
                    <p class="">{{ project.project_status }}</p>
                  </span>
                  <p class="">{{ project.project_description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="activeProfileTab === 'Investment Portfolio'">
          <div v-if="hasRole('investor')">
            <InvestorProjects
              :projects="joinedProjects"
              :joined-projects="joinedProjects"
              :loading="loading"
              :total-amount-invested="totalAmountInvested"
            />
          </div>
          <div v-else class="text-center py-20">
            <p class="text-gray-600">You don't have investor access yet.</p>
            <button class="mt-4 px-4 py-2 bg-primaryDarkBg text-white rounded">
              Request Investor Access
            </button>
          </div>
        </div>

        <div v-else-if="activeProfileTab === 'Earned Badges'">
          <div v-if="hasRole('talent')">
            <div class="mt-10">
              <p class="text-primaryDark mb-4">Milestones and Achievements</p>
              <div class="grid grid-cols-3 md:grid-cols-3 gap-4">
                <div
                  class="flex p-4 items-start border border-[#EEEEEE] bg-[#F0F2F5] rounded-[8px]"
                >
                  <img
                    src="@/assets/users/TrophyStar.svg"
                    alt="trophy star badge"
                    class="h-16"
                  />
                  <div class="space-y-1 ml-4 text-[14px] text-grayDark">
                    <span class="text-bodyText font-medium space-y-1">
                      <p class="">1000 hours of logged time</p>
                    </span>
                    <p class="text-[11px]">
                      To earn achieve 1000 hours of logged time on a public
                      project
                    </p>
                  </div>
                  <div
                    class="flex justify-center items-center min-w-[24px] min-h-[24px] w-6 h-6 rounded-full bg-[#1BFF00]"
                  >
                    <img
                      src="@/assets/users/tick.svg"
                      alt="trophy star badge"
                      class="h-4 w-4"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="text-center py-20">
            <p class="text-gray-600">You don't have talent access yet.</p>
            <button class="mt-4 px-4 py-2 bg-primaryDarkBg text-white rounded">
              Request to be a talent
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Glass Overlay -->
    <div
      v-if="isSideMenuOpen"
      class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"
      @click="closeSideMenu"
    ></div>

    <div
      v-if="isSideMenuOpen"
      class="fixed top-0 right-0 w-[543px] h-full bg-white shadow-lg z-50 transform transition-transform duration-300 text-[14px]"
    >
      <div class="space-y-4">
        <div
          class="py-4 px-4 flex justify-between items-center border-b-[1px] border-grayLight"
        >
          <h3 class="text-lg font-medium">
            {{ selectedProject?.project_name }}
          </h3>

          <div class="flex space-x-2 items-center">
            <img
              src="@/assets/tasks/paperclip.svg"
              alt="Options"
              class="h-6 cursor-pointer"
            />
            <img
              src="@/assets/projects/options.svg"
              alt="Options"
              class="h-6 cursor-pointer"
            />
            <div
              @click="closeSideMenu"
              class="bg-[#FAFBFC] h-8 rounded-full flex items-center justify-center"
            >
              <img
                src="@/assets/tasks/iconoir_cancel.svg"
                alt="Options"
                class="h-6 cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="px-5 py-4 space-y-4 text-grayDark text-[13px]">
        <div class="space-y-3">
          <div class="grid grid-cols-2 gap-4">
            <div
              class="space-y-4 item-center border border-grayLight py-4 px-4 rounded-[12px]"
            >
              <p>Status</p>
              <span class="text-[15px] font-semibold">{{
                selectedProject?.project_status
              }}</span>
            </div>
            <div
              class="space-y-4 item-center border border-grayLight py-4 px-4 rounded-[12px]"
            >
              <p>Timeline</p>
              <span class="text-[15px] font-semibold"
                >{{ selectedProject?.project_start_date }} -
                {{ selectedProject.project_end_date }}</span
              >
            </div>
            <div
              class="space-y-4 item-center border border-grayLight py-4 px-4 rounded-[12px]"
            >
              <p>Task Completed</p>
              <span class="text-[15px] font-semibold">{{
                selectedProject?.project_status
              }}</span>
            </div>
          </div>

          <div
            class="space-y-4 item-center border border-grayLight py-4 px-4 rounded-[12px]"
          >
            <div class="items-center">
              <p class="font-semibold text-bodyText text-[15px]">
                Project Description
              </p>
            </div>
            <span class="">{{ selectedProject?.project_description }}</span>
          </div>
          <div
            class="space-y-4 item-center border border-grayLight py-4 px-4 rounded-[12px]"
          >
            <div class="items-center">
              <p>Technologies Used</p>
            </div>
            <span class="">{{
              selectedMember?.talent_email || selectedMember?.user.email
            }}</span>
          </div>

          <div
            class="space-y-4 item-center border border-grayLight py-4 px-4 rounded-[12px]"
          >
            <div class="items-center">
              <p>Team Members</p>
            </div>
            <span class="">{{ selectedMember?.talent_phone }}</span>
          </div>
        </div>
      </div>
    </div>

    <UpdateModal
      :show="showUpdateModal"
      :field-type="currentFieldType"
      :current-value="currentFieldValue"
      :talent-data="talent"
      @close="closeUpdateModal"
      @updated="handleProfileUpdate"
    />
  </div>

  <div
    v-if="copyTooltip.show"
    class="fixed z-[9999] bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg pointer-events-none"
    :style="{ left: copyTooltip.x + 'px', top: copyTooltip.y + 'px' }"
  >
    {{ copyTooltip.text }}
  </div>
</template>

<script>
import apiClient from "@/axios";
import UserAvatar from "../auth/UserAvatar.vue";
import NavbarComponent from "../NavbarComponent.vue";
import SkeletonLoader from "../SkeletonLoader.vue";

import TabComponent from "./TabComponent.vue";
import UpdateModal from "../modals/UpdateModal.vue";
import { createTabStateManager } from "@/utils/tabStateManager";
import InvestorProjects from "../project/InvestorProjects.vue";

export default {
  name: "TalentProfile",
  components: {
    UserAvatar,
    NavbarComponent,
    SkeletonLoader,
    TabComponent,
    UpdateModal,
    InvestorProjects,
  },
  data() {
    return {
      activeTab: null,
      activeProfileTab: "About",
      // activeTaskTab: "To-do",
      activeInvestorProfileTab: "Invested Projects",
      // profileTabs: [
      //   "About",
      //   "Talent Portfolio",
      //   "Investment Portfolio",
      //   "Management Portfolio",
      //   "Earned Badges",
      // ],
      taskTabs: ["To-do", "Done"],
      investorProfileTabs: ["Invested Projects", "Overview"],
      // projects: [],
      talentProjects: [],
      managerProjects: [],
      investorProjects: [],
      talent: "",
      investor: "",
      manager: "",
      user: {},
      completedTasksCount: 0,
      allNonCompletedTasks: [],
      loading: true,
      newBio: {
        bio: "",
      },
      showModal: false,
      showUpdateModal: false,
      currentFieldType: null,
      currentFieldValue: "",
      isSideMenuOpen: false,

      selectedProject: null,
      selectedProjectMembers: [],

      mainTabStateManager: null,
      deviceTabStateManager: null,

      // Storage listeners
      mainTabStorageListener: null,
      deviceTabStorageListener: null,
      joinedProjects: [],
      totalAmountInvested: 0,

      copyTooltip: { show: false, text: "", x: 0, y: 0 },
    };
  },
  watch: {
    activeProfileTab: {
      handler(newTab) {
        if (this.mainTabStateManager && newTab) {
          this.mainTabStateManager.setActiveTab(newTab);
          console.log("Main settings tab changed to:", newTab);
        }
      },
      immediate: false,
    },

    // Watch device settings sub-tab changes
    activeTaskTab: {
      handler(newTab) {
        if (this.deviceTabStateManager && newTab) {
          this.deviceTabStateManager.setActiveTab(newTab);
          console.log("Device settings tab changed to:", newTab);
        }
      },
      immediate: false,
    },

    // Reinitialize when user changes
    "$store.state.user": {
      handler(newUser, oldUser) {
        if (newUser && newUser !== oldUser) {
          this.initAllTabStates();
        }
      },
      deep: true,
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isInvestor() {
      return this.$store.getters.isInvestor;
    },
    isUser() {
      return this.$store.getters.isUser;
    },

    fullName() {
      if (
        !this.talent ||
        (!this.talent.talent_first_name && !this.talent.talent_last_name)
      ) {
        return "";
      }
      return `${this.talent.talent_first_name || ""} ${
        this.talent.talent_last_name || ""
      }`.trim();
    },
    completedProjectsCount() {
      if (
        !this.talent ||
        !this.talent.projects ||
        !this.talent.projects.length
      ) {
        return 0;
      }

      return this.talent.projects.filter(
        (project) => project.project_status === "Completed"
      ).length;
    },

    userIdentifier() {
      return this.user?.user_id || this.$store.state.user?.user_id || "default";
    },

    joinedProjectsCount() {
      return Array.isArray(this.joinedProjects)
        ? this.joinedProjects.length
        : 0;
    },
    profileTabs() {
      return [
        "About",
        "Talent Portfolio",
        "Investment Portfolio",
        // "Management Portfolio",
        "Earned Badges",
      ];
    },
  },

  methods: {
    initAllTabStates() {
      this.cleanupStorageListeners();
      this.initMainTabState();
      this.initTaskTabState();
      this.initInvestorTabState();
    },

    initMainTabState() {
      const userSpecificKey = `profile_mainTab_${this.userIdentifier}`;

      this.mainTabStateManager = createTabStateManager(
        userSpecificKey,
        "About",
        this.profileTabs
      );

      this.activeProfileTab = this.mainTabStateManager.getActiveTab();

      this.mainTabStorageListener = (e) => {
        if (e.key === userSpecificKey && e.newValue) {
          this.activeProfileTab = e.newValue;
        }
      };

      window.addEventListener("storage", this.mainTabStorageListener);
    },

    initTaskTabState() {
      const userSpecificKey = `profile_taskTab_${this.userIdentifier}`;

      this.taskTabStateManager = createTabStateManager(
        userSpecificKey,
        "To-do",
        this.taskTabs
      );

      this.activeTaskTab = this.taskTabStateManager.getActiveTab();

      this.taskTabStorageListener = (e) => {
        if (e.key === userSpecificKey && e.newValue) {
          this.activeTaskTab = e.newValue;
        }
      };

      window.addEventListener("storage", this.taskTabStorageListener);
    },

    initInvestorTabState() {
      const userSpecificKey = `profile_investorTab_${this.userIdentifier}`;

      this.investorTabStateManager = createTabStateManager(
        userSpecificKey,
        "Invested Projects",
        this.investorProfileTabs
      );

      this.activeInvestorProfileTab =
        this.investorTabStateManager.getActiveTab();

      this.investorTabStorageListener = (e) => {
        if (e.key === userSpecificKey && e.newValue) {
          this.activeInvestorProfileTab = e.newValue;
        }
      };

      window.addEventListener("storage", this.investorTabStorageListener);
    },

    cleanupStorageListeners() {
      if (this.mainTabStorageListener) {
        window.removeEventListener("storage", this.mainTabStorageListener);
      }
      if (this.taskTabStorageListener) {
        window.removeEventListener("storage", this.taskTabStorageListener);
      }
      if (this.investorTabStorageListener) {
        window.removeEventListener("storage", this.investorTabStorageListener);
      }
    },

    cleanupOldTabPreferences() {
      // Clean up any old non-user-specific keys
      const keysToCleanup = [
        "activeProfileTab",
        "activeTaskTab",
        "activeInvestorProfileTab",
      ];
      keysToCleanup.forEach((key) => {
        if (localStorage.getItem(key)) {
          localStorage.removeItem(key);
        }
      });
    },

    openSideMenu(project) {
      this.selectedProject = { ...project };
      this.isSideMenuOpen = true;

      // Fetch members when a project is selected
      if (project && project.project_id) {
        this.fetchProjectMembers(project.project_id);
      }
    },
    
    goToProject(projectId) {
      this.$router.push({ name: "ProjectDetails", params: { projectId } });
    },
    
    closeSideMenu() {
      this.isSideMenuOpen = false;
      this.selectedMember = null;

    },
    openUpdateModal(fieldType, currentValue = "") {
      this.currentFieldType = fieldType;
      this.currentFieldValue = currentValue;
      this.showUpdateModal = true;
    },

    closeUpdateModal() {
      this.showUpdateModal = false;
      this.currentFieldType = null;
    },

    handleProfileUpdate(data) {
      // Update local data based on what was changed
      if (data.type === "bio") {
        this.talent.bio = data.value;
      } else if (data.type === "portfolio") {
        this.talent.portfolio_url = data.value;
      } else if (data.type === "position") {
        this.talent.position = data.value;
      } else if (data.type === "skills") {
        this.talent.skills = data.value;
      }

      // Show success message
      this.$toast.success(`${this.capitalize(data.type)} updated successfully`);

      // Refresh data
      this.fetchProfileData();
    },

    // capitalizeFirstLetter(string) {
    //   return string.charAt(0).toUpperCase() + string.slice(1);
    // },

    createBio() {
      this.openUpdateModal("bio");
      this.talent.bio;
    },

    updatePortfolio() {
      this.openUpdateModal("portfolio", this.talent.portfolio_url);
    },

    updatePosition() {
      this.openUpdateModal("position", this.talent.position);
    },
    addSkills() {
      this.openUpdateModal("skills", this.talent.skills);
    },
    async submitModal() {
      try {
        const newProjectWithManager = {
          ...this.newProject,
          manager_id: this.selectedManagerId,
        };
        const response = await apiClient.post(
          "/web/projects",
          newProjectWithManager
        );
        const createdProject = response.data.data;

        this.$emit("projectCreated", "Project created successfully!");
        this.$emit("refresh");
        this.closeModal();

        if (createdProject && createdProject.project_id) {
          this.$router.push(`/projects/${createdProject.project_id}`);
        }
      } catch (error) {
        this.$toast.error(
          error.response?.data?.message || "An unexpected error occurred."
        );
        console.error("Error creating project:", error);
      }
    },

    setActiveTab(tab) {
      this.activeTab = tab;
    },
    async fetchProfileData() {
      try {
        const availableRoles = this.getAvailableRoles();

        // Fetch talent data if user has talent role
        if (availableRoles.includes("talent")) {
          const talentResponse = await apiClient.get("/web/talent/me");
          this.talent = talentResponse.data.data || {};
          this.talentProjects = this.talent.projects || [];
        }

        // Fetch manager data if user has manager role
        if (availableRoles.includes("manager")) {
          const managerResponse = await apiClient.get("/web/manager/me");
          this.manager = managerResponse.data.data || {};
          this.managerProjects = this.manager.projects || [];

          // this.projects = [...(this.projects || []), ...(this.manager.projects || [])];
        }

        // Fetch investor data if user has investor role
        if (availableRoles.includes("investor")) {
          const investorResponse = await apiClient.get(
            "/web/projects/Investor/all?invested_only=true"
          );
          const investorData = await apiClient.get("/web/investor/me");
          this.joinedProjects = investorResponse.data.data || [];
          this.investor = investorData.data.data || [];
        }

        this.fetchCompletedTasks();
      } catch (error) {
        console.error("Error fetching profile data:", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchCompletedTasks() {
      try {
        let totalCompletedTasks = 0;
        let totalNonCompletedTasks = 0;

        if (
          this.talent &&
          this.talent.projects &&
          this.talent.projects.length > 0
        ) {
          for (const project of this.talent.projects) {
            const response = await apiClient.get(
              `/web/projects/${project.project_id}/tasks`
            );
            const tasks = response.data.data || [];

            console.log(`Tasks for project ${project.project_id}:`, tasks);
            // Filter tasks that belong to this talent and are completed
            const completedTasks = tasks.filter(
              (task) => task.task_status === "Completed"
              // task.assigned_to === this.talent.talent_id
            );

            const nonCompletedTasks = tasks.filter(
              (task) =>
                // task.task_status === 'In Progress' || task.task_status === 'Not Started'
                task.task_status === "Not Started"
            );

            totalNonCompletedTasks += nonCompletedTasks;
            totalCompletedTasks += completedTasks.length;
          }
        }
        this.allNonCompletedTasks = totalNonCompletedTasks;
        console.log("Non completed tasks", this.totalNonCompletedTasks);
        console.log("Non completed tasks", this.allNonCompletedTasks);
        this.completedTasksCount = totalCompletedTasks;
        console.log("Total completed tasks:", this.completedTasksCount);
      } catch (error) {
        console.error("Error fetching tasks for projects:", error);
        this.completedTasksCount = 0; // Set to 0 on error
      }
    },
    async fetchProjectMembers(projectId) {
      try {
        const response = await apiClient.get(
          `/web/projects/${projectId}/project_members/`
        );
        this.members = response.data.data;
      } catch (error) {
        console.error("Error fetching members data:", error);
      }
    },
    capitalize(text) {
      if (!text) return "";
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },

    openEmailClient(email) {
      const subject = encodeURIComponent("Contact from Profile");
      const body = encodeURIComponent(
        "Hi,\n\nI found your profile and would like to get in touch.\n\nBest regards"
      );
      window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
    },

    openUrl(url) {
      if (url) {
        // Add https:// if no protocol is specified
        const fullUrl = url.startsWith("http") ? url : `https://${url}`;
        window.open(fullUrl, "_blank");
      }
    },
    getAvailableRoles() {
      const roles = localStorage.getItem("availableRoles");
      return roles ? JSON.parse(roles) : [];
    },

    hasRole(role) {
      return this.getAvailableRoles().includes(role);
    },
    async fetchCurrentUser() {
      try {
        const response = await apiClient.post("/current_user");
        this.user = response.data.user || {};
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    getProfilePicture() {
      return this.user.profile_picture || null;
    },
    async copyWithTooltip(event, text, message) {
      try {
        await navigator.clipboard.writeText(text);
        this.showTooltip(event, message);
      } catch (err) {
        console.error("Failed to copy: ", err);
        this.fallbackCopyWithTooltip(event, text, message);
      }
    },

    fallbackCopyWithTooltip(event, text, message) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.showTooltip(event, message);
        }
      } catch (err) {
        console.error("Fallback copy failed", err);
      }

      document.body.removeChild(textArea);
    },

    showTooltip(event, text) {
      const rect = event.target.getBoundingClientRect();
      this.copyTooltip = {
        show: true,
        text: text,
        x: rect.left + rect.width / 2 - 40, // Center tooltip above icon
        y: rect.top - 35, // Position above the icon
      };

      setTimeout(() => {
        this.copyTooltip.show = false;
      }, 2000);
    },
  },
  mounted() {
    if (this.isInvestor) {
      this.activeTab = "invested_projects";
    } else if (this.isTalent || this.isAdmin || this.isManager) {
      this.activeTab = "my_tasks";
    }

    this.fetchCurrentUser(); // Fetch user data to get profile picture
    this.fetchProfileData();
    this.fetchCompletedTasks();
    this.fetchProjectMembers();
  },
  created() {
    // this.fetchProfileData();
    // Initialize tab state first (after user data is available)
    this.$nextTick(() => {
      this.initAllTabStates();
    });

    // Clean up old preferences
    this.cleanupOldTabPreferences();
  },
  beforeUnmount() {
    // Use beforeDestroy() if using Vue 2
    this.cleanupStorageListeners();
  },
};
</script>
